import { render, staticRenderFns } from "./65.vue?vue&type=template&id=50802e41&scoped=true&"
var script = {}
import style0 from "./65.vue?vue&type=style&index=0&id=50802e41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50802e41",
  null
  
)

export default component.exports